import { Component, EventEmitter, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PageEvent } from '@angular/material/paginator';
import { DataService } from 'src/app/services/data.service';
import {AirConfigService}  from 'src/app/services/air-config.service'
import {AirManagementService}  from 'src/app/services/air-management.service'

import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl, RequiredValidator } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { Router ,ActivatedRoute} from '@angular/router';
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { TagService } from 'src/app/services/tag.service';

@Component({
  selector: 'app-rbd',
  templateUrl: './rbd.component.html',
  styleUrls: ['./rbd.component.css']
})
export class RbdComponent {
  numbers: number[] = Array.from({ length: 25 }, (_, i) => i + 1);

  columnsDisplay: string[] = ['supplier','source','iata','paymentChannel','action'];
  // columnsDisplay: string[] = ['supplier','source','iata','rbdDom','rbdInt','regions','applyOn','chargeOb'];
  paymentChannelList:any
  faredata:any
  expandedElement!: any | null;
  totalElements:any=0
  addfare:any={
    boolean:false,
  action:''}
  action:any
rbdRequest:any={
  "carrierCode":"",
    "domestic":"",
    "international":"",
    "paymentChannel":"",
    "sourceId":"",
    "supplierId": "",
    "regions":"",
    "scope": "",
    "status":"A",
    "paymentChannelRef":"",
    "paymentChannelTags":null,
    "carrierBookingClass":""

}
searchRequest:any={
  "carrierCode":"",
    "sourceId":"",
    "supplierId": "",

}

  carrierList:any=[]
searchText:any=''
disabled:boolean=false

  constructor(private DataService:DataService,private route :ActivatedRoute,private PaymentConfigService:PaymentConfigService,private TagService:TagService,
    private AirConfigService:AirConfigService,private fb : FormBuilder,    private toastMsgService : ToastmsgService,private AirManagementService:AirManagementService){
    this.DataService.portMessage.subscribe((item:any)=>this.addfare=item)
    this.sourceCodelist()
    this.Carrierlist()
    this.supplierlist()
    this.RBDList()
    this.paymentChannels()
    // this.fareList({page: this.pagestr.number, size: this.pagestr.size,})
    
this.creditList()

this.tagList()

      
     
  
    


  }
  myControl = new FormControl('');
filteredOptions!: Observable<any>;
carrierCodeList:any=[]


private _filters(value: string): string[] {
  const filterValue = value.toLowerCase();

  return this.carrierList.filter((option:any) => option.airlineDesignatorCode.toLowerCase().includes(filterValue)||option.carrierName.toLowerCase().includes(filterValue));
}
changeCarrier(){
  this.rbdRequest.carrierCode=this.myControl.value?.split(',')[1]
}
  ngOnInit(): void {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value:any) => this._filters(value || '')),
    );
    
  }
  pagestr:any={
    number:'0',
    size:'10'
  }

  searchSource(){

  }
  nextPage(event:PageEvent) {
    
    let page:any = {};
    page['page'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
    // this.fareList(page)

  }
  popup:boolean=false
  closePopup(){
this.popup=false
this.blankDetail()
  }
 
  Carrierlist(){

    this.AirManagementService
    .carrierlist()
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.carrierList=data
       

        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }

  sourceCodeList:any=[]
sourceCodelist(){

  this.AirManagementService
  .sourceCodelist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.sourceCodeList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
paymentChannels(){

  this.AirConfigService
  .getPaymentChannels()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.paymentChannelList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}


AddRBD() {
  if( this.rbdRequest.paymentChannelRef){
  this.rbdRequest.paymentChannelRef=this.rbdRequest.paymentChannelRef.join(':')}
         this.disabled=true
         this.AirConfigService.saveRbd(this.rbdRequest)
           .subscribe({
             next : (res) => {
              this.disabled=false
let data:any=res?.body
if(data){


               if(data.resStatus==='CREATED') {
                  this.toastMsgService.setMsg({msg : " RBD Added Successfully!",msgTitle : "Success", msgType : "I"});
               this.popup=false
                
               
                //  this.fareList({page: this.pagestr.number, size: this.pagestr.size,})
               } else {
                if(data.message){
                  if( this.rbdRequest.paymentChannelRef){
                    this.rbdRequest.paymentChannelRef=this.rbdRequest?.paymentChannelRef.split(':')}
                    this.toastMsgService.setMsg({msg : data.message,msgTitle : "Warning", msgType : "W"});
                }else{
                  const body : any = res.body;

                  this.registerSourceErrorMsg(res.status,body?.result);
                }
                

               } 
              }else{
                const body : any = res.body;

                this.registerSourceErrorMsg(res.status,body?.result);

              }
             },error : (err) => {

              this.disabled=false

               this.registerSourceErrorMsg(err.status,err.error);
             }
           }
         )
       }
     
       registerSourceErrorMsg(status : number,msg : string) {
        if( this.rbdRequest.paymentChannelRef){
          this.rbdRequest.paymentChannelRef=this.rbdRequest?.paymentChannelRef.split(':')}
          this.toastMsgService.setMsg({msg : "Failed to Save RBD",msgTitle : "Warning", msgType : "W"});

       }


       rbdList:any=[]
       RBDList(){
        this.disabled=true

      let request:any={
        
          "carrierCode": this.searchRequest?.carrierCode,
           "supplierId": this.searchRequest?.supplierId,
          "sourceId": this.searchRequest?.sourceId,
      
      }
      
      
     
         this.AirConfigService
         .rbdList(request)
         .subscribe({
           next : (res:any) => {
            this.disabled=false

             if(res) {
              
            let data=res?.result
            this.rbdList=data
             } else {
             
             } 
           },error : (err) => {
            this.disabled=false

           }
         }
       )
       }
       onlyNumberKey(event:any) {
     
        let charCode = (event.which) ? event.which : event.keyCode;
        if (charCode != 46 && charCode > 31
            && (charCode < 48 || charCode > 57))
            return false;
        return true;
      }

      blankDetail(){
        
      }
      rbdAction:any=""
      onCarrierChange(){
        if(this.rbdRequest.carrierCode){
          this.rbdRequest.carrierBookingClass=""

        }else{
          this.rbdRequest.carrierBookingClass=null
        }
      }
      id:any
      rowClick(element:any){
        this.rbdAction="Update"
        this.popup=true
this.id=element?.id
     this.rbdRequest={
      "carrierCode":element?.carrierCode,
        "domestic":element?.domestic,
        "international":element?.international,
        "paymentChannel":element?.paymentChannel,
        "sourceId":element?.sourceId,
        "supplierId": element?.supplierId,
        "regions":element?.regions,
        "scope": element?.scope,
        "status":element?.status,
        "paymentChannelRef":element?.paymentChannelRef?.split(':')||null,
        "paymentChannelTags":element?.paymentChannelTags,
         "carrierBookingClass":element?.carrierBookingClass,

    
    }


    if(element?.paymentChannelTags){
      this.PaymentType='A'
    }else{
      this.PaymentType='M'
    }

      }
      filterCarrier(item:any){
        if(item){
          let carrier=this.carrierList.filter((itm:any)=>itm?.airlineDesignatorCode===item)
          // console.log(carrier)
          return carrier[0]?.carrierName
        }else{
          return item
        }
        
      }
      filterSource(item:any){
        if(item){
          let source=this.sourceCodeList.filter((itm:any)=>itm?.code===item)
          return source[0]?.title
        }else{
          return item
        }
        
      }

      filterSupplier(item:any){
        if(item){
          let supplier=this.supplierList.filter((itm:any)=>itm?.code===item)
          return supplier[0]?.name
        }else{
          return item
        }
        
      }
      onMenuClick(event: any) {
        event.preventDefault();
        event.stopPropagation();
        
      
      }
      supplierList:any
    supplierlist(){
     
      this.AirManagementService
      .supplierlist()
      .subscribe({
        next : (res:any) => {
          if(res) {
         let data:any=[]
         data=res
         
        this.supplierList=data;
       
          } else {
          
          } 
        },error : (err) => {
  
        }
        
      }
      
    )
    }
    disable(){

      if(this.PaymentType==='A'){
      if(this.rbdRequest.paymentChannelTags&&this.rbdRequest.paymentChannelTags!=0){
       return false
      }else{
        return true

      }}else if(this.PaymentType==='M'){
        if(this.rbdRequest.paymentChannel &&this.rbdRequest.sourceId && this.rbdRequest.supplierId ){

          if(this.rbdRequest.paymentChannel==='CARD'){
            if(this.rbdRequest.paymentChannelRef.length>0){
              return false
  
            }else{
              return true
  
            }
          }
         return false
        }else{
          return true
  
        }
      }else{
        return true

      }
    }
    OnClickPopup(){
      this.rbdAction="new"
      this.PaymentType='M'
      this.rbdRequest={
        "carrierCode":"",
          "domestic":"",
          "international":"",
          "paymentChannel":"",
          "sourceId":"",
          "supplierId": "",
          "regions":"",
          "scope": "",
          "status":"A",
          "paymentChannelRef":"",
          "paymentChannelTags":null
      }

      // this.creditList()

      this.popup=true
    }
    CreditData:any=[]
    creditList(){

      this.PaymentConfigService
      .creditCardList()
      .subscribe({
        next : (res:any) => {
          if(res) {
            let data=res
         this.CreditData=data
        //  console.log(this.CreditData)
          } else {
          
          } 
        },error : (err) => {
  
        }
      }
    )
    }

    updateRBD(){

        if( this.rbdRequest.paymentChannelRef){
        this.rbdRequest.paymentChannelRef=this.rbdRequest.paymentChannelRef.join(':')}
               this.disabled=true
               this.AirConfigService.updatedRbd(this.rbdRequest,this.id)
                 .subscribe({
                   next : (res) => {
                    this.disabled=false
                    let data:any=res?.body
if(data){
                     if( data.resStatus=='ACCEPTED') {
                        this.toastMsgService.setMsg({msg : "RBD Updated Successfully!",msgTitle : "Success", msgType : "I"});
                     this.popup=false
                      
                     this.RBDList()
                      //  this.fareList({page: this.pagestr.number, size: this.pagestr.size,})
                     } else {
                      
                       if(data.message){
                        if( this.rbdRequest.paymentChannelRef){
                          this.rbdRequest.paymentChannelRef=this.rbdRequest?.paymentChannelRef.split(':')}
                          this.toastMsgService.setMsg({msg : data.message,msgTitle : "Warning", msgType : "W"});
                      }else{
                        const body : any = res.body;
                       this.registerUpdateSourceErrorMsg(res.status,body?.result);
                      }
      
                     } }else{
                      const body : any = res.body;
                      this.registerUpdateSourceErrorMsg(res.status,body?.result);
                     }
           
                   },error : (err) => {
      
                    this.disabled=false
      
                     this.registerUpdateSourceErrorMsg(err.status,err.error);
                   }
                 }
               )
             }
           
             registerUpdateSourceErrorMsg(status : number,msg : string) {
             
              if( this.rbdRequest.paymentChannelRef){
                this.rbdRequest.paymentChannelRef=this.rbdRequest.paymentChannelRef.split(':')}
                this.toastMsgService.setMsg({msg : "Failed to Update RBD",msgTitle : "Warning", msgType : "W"});
             }
             creditDetail(cardDetail:any,source:any){
             return cardDetail.filter((item:any)=>item.sources===source)
             }

             tagDataList:any=[]
             tagList(){

              this.TagService
              .getTagAllList()
              .subscribe({
                next : (res:any) => {
                  if(res) {
                    let data=res?.results||[]
                 this.tagDataList=data
                //  console.log(this.CreditData)
                  } else {
                  
                  } 
                },error : (err) => {
          
                }
              }
            )
            }
            PaymentType:any="M"
            onSelectionChange(){
              if(this.PaymentType==='M'){
                this.rbdRequest={
                  "carrierCode":this.rbdRequest.carrierCode,
                    "domestic":this.rbdRequest.domestic,
                    "international":this.rbdRequest.international,
                    "paymentChannel":this.rbdRequest.paymentChannel,
                    "sourceId":this.rbdRequest.sourceId,
                    "supplierId": this.rbdRequest.supplierId,
                    "regions":this.rbdRequest.regions,
                    "scope": this.rbdRequest.scope,
                    "status":this.rbdRequest.status,
                    "paymentChannelRef":this.rbdRequest.paymentChannelRef,
                    "paymentChannelTags":null,
                    "carrierBookingClass":this.rbdRequest.carrierBookingClass,

                
                }
              }else if(this.PaymentType==='A'){
                this.rbdRequest={
                  "carrierCode":this.rbdRequest.carrierCode,
                  "domestic":this.rbdRequest.domestic,
                  "international":this.rbdRequest.international,
                  "paymentChannel":null,
                  "sourceId":this.rbdRequest.sourceId,
                  "supplierId": this.rbdRequest.supplierId,
                  "regions":this.rbdRequest.regions,
                  "scope": this.rbdRequest.scope,
                  "status":this.rbdRequest.status,
                  "paymentChannelRef":null,
                  "paymentChannelTags":[],
                  "carrierBookingClass":this.rbdRequest.carrierBookingClass,

                }
              }
            }
        
}
